import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@tonic-one/react';
import React from 'react';

const DisabledWarningTip = ({
  popoverTriggerContent,
  popoverTrigger,
}: {
  popoverTriggerContent: string;
  popoverTrigger: JSX.Element;
}) => {
  return (
    <Popover trigger="hover">
      <PopoverTrigger>
        <Text display="inline-block">{popoverTrigger}</Text>
      </PopoverTrigger>
      <PopoverContent
        PopperProps={{
          modifiers: [
            {
              // https://popper.js.org/docs/v2/modifiers/flip/
              name: 'flip',
              enabled: true,
            },
          ],
        }}
      >
        {popoverTriggerContent}
      </PopoverContent>
    </Popover>
  );
};

export default DisabledWarningTip;
